import React, {Component} from 'react';
import {getCellBgColor} from 'helpers/common-helper';
import {getGameTeamNames} from 'helpers/game-helper';

class BaseGameTotal extends Component {
    getBackgroundColor(gameTotal) {
        const {sportConfig} = this.props;
        const shadingOptions = sportConfig.getShadingOptions();

        return getCellBgColor(gameTotal * 1, shadingOptions.gameTotal);
    }

    getImpliedGameTotal() {
        const {game, teams} = this.props;
        const teamNames = getGameTeamNames(game);

        let total = 0;
        if (Object.keys(teams).length) {
            teamNames.forEach((teamName) => {
                if (typeof teams[teamName] !== 'undefined') {
                    total += Number(teams[teamName].implied_run_totals);
                }
            });
        }
        return total;
    }

    getGameTotal() {
        const {game} = this.props;
        return game.gameTotal;
    }
}

export default BaseGameTotal;
